export const userAssetsQueryParams =
  'includeMetadata=true&includeArchived=false&limit=5000';

export enum UserAssetsQueryTagTypes {
  ASSETS = 'Assets',
}
